import React from 'react'

import Navbar from '../components/navbar/navbar'
import PricingOne from '../components/pricing-one'
import FooterTop from '../components/footer-top'
import Footer from '../components/footer'

export default function Pricing() {
  return (
    <>
        <Navbar transparent={false}/> 

        {/* <div className="page-title">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                        <h2 className="ipt-title">Pricing</h2>
                        <span className="ipn-subtitle">Lists of our all Popular agencies</span>
                    </div>
                </div>
            </div>
        </div>   */}

        <section>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-7 col-md-10 text-center">
                        <div className="sec-heading center">
                            <h2>Select a Plan</h2>
                        </div>
                    </div>
                </div>
                <PricingOne/>
            </div>	
        </section>
        <Footer/>
    </>
  )
}
